<template>
    <div class="brand-area pb-60 d-none d-lg-block">
        <div class="container">
            <!-- Brand Banner Start -->
            <div class="brand-banner owl-carousel">
      <swiper :slides-per-view="5"
              :space-between="50"
              loop
              @swiper="onSwiper"
              @slideChange="onSlideChange"
      >
        <swiper-slide v-for="dataPhoto in brands_photo.value" :key="dataPhoto.id">
            <div class="single-brand">
                <a v-bind:href="'/brand/'+ dataPhoto.title">
                    <template v-if="dataPhoto.photo.path_webp != null">
                        <picture>
                            <source v-bind:srcset="'../storage/photos/'+dataPhoto.photo.path_webp" type="image/webp">
                            <source v-bind:srcset="'../storage/photos/'+dataPhoto.photo.path" type="image/png">
                            <img class="primary-img" width="100" height="35" v-bind:src="'../storage/photos/'+dataPhoto.photo.path" v-bind:alt="dataPhoto.dec" v-bind:title="dataPhoto.title">
                        </picture>
                    </template>
                    <template v-if="dataPhoto.photo.path_webp == null">
                        <img class="primary-img" width="100" height="35" v-bind:src="'../storage/photos/'+dataPhoto.photo.path" v-bind:alt="dataPhoto.dec" v-bind:title="dataPhoto.title">
                    </template>
                </a>
        </div></swiper-slide>

    </swiper>
            </div>
        </div>
    </div>
    <div class="brand-area pb-60 d-lg-none">
        <div class="container">
            <!-- Brand Banner Start -->
            <div class="brand-banner owl-carousel">
                <swiper :slides-per-view="2"
                        :space-between="50"
                        loop
                        @swiper="onSwiper"
                        @slideChange="onSlideChange"
                >
                    <swiper-slide v-for="dataPhoto in brands_photo.value" :key="dataPhoto.id">
                        <div class="single-brand">
                            <a v-bind:href="'/brand/'+ dataPhoto.title">
                                <template v-if="dataPhoto.photo.path_webp != null">
                                    <picture>
                                        <source v-bind:srcset="'../storage/photos/'+dataPhoto.photo.path_webp" type="image/webp">
                                        <source v-bind:srcset="'../storage/photos/'+dataPhoto.photo.path" type="image/png">
                                        <img class="primary-img" width="100" height="35" v-bind:src="'../storage/photos/'+dataPhoto.photo.path" v-bind:alt="dataPhoto.dec" v-bind:title="dataPhoto.title">
                                    </picture>
                                </template>
                                <template v-if="dataPhoto.photo.path_webp == null">
                                    <img class="primary-img" width="100" height="35" v-bind:src="'../storage/photos/'+dataPhoto.photo.path" v-bind:alt="dataPhoto.dec" v-bind:title="dataPhoto.title">
                                </template>
                            </a>
                        </div></swiper-slide>

                </swiper>
            </div>
        </div>
    </div>
</template>

<script>
    import {reactive} from 'vue'
    import axios from 'axios'
    //import { EffectFade } from 'swiper';
    import { Swiper, SwiperSlide } from 'swiper/vue';

    import 'swiper/css';
    //import 'swiper/css/effect-fade';

    export default {
        components: {
            Swiper,
            SwiperSlide,
        },
        name: "BrandShow",
        setup() {
            const brands_photo = reactive([]);
            const getphoto = async() => {
                try {
                    await axios.get('/api/brands-photo')
                        .then(res => {
                            brands_photo.value = res.data;
                        })
                }catch (e) {
                    this.errors.push(e)
                }

            };
            const onSwiper = (swiper) => {

            };
            const onSlideChange = () => {

            };
            getphoto();
            return {
                onSwiper,
                onSlideChange,
                brands_photo

            };
        },
    }
</script>

<style scoped>

</style>
